import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { InputFieldWrapper, Label, Error } from "./Datefield";

interface Props {
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: () => void;
  name?: string;
  uploadedImage: any;
  required?: boolean;
  helperText?: string;
}

interface StyledInputProps {
  helperText?: string;
  disabled?: boolean;
}

const UploadFile = ({
  onChange,
  onRemove,
  label,
  name,
  required,
  helperText,
  uploadedImage,
}: Props) => {
  return (
    <>
      <InputFieldWrapper>
        {label && (
          <Label>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <UploadWrapper>
          <InputField
            onChange={onChange}
            name={name}
            helperText={helperText}
            autoComplete="off"
            type="file"
            accept=".png, .jpeg, .jpg"
            id="actual-btn"
            hidden
            onClick={(e: any) => (e.target.value = "")}
          />
          <UploadFileWrapper>
            <UploadButton htmlFor="actual-btn" disabled={uploadedImage}>
              Browse
            </UploadButton>
            <UploadMessage>
              Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 1344x756.
            </UploadMessage>
          </UploadFileWrapper>
        </UploadWrapper>
        {helperText && <Error>{helperText}</Error>}
        {uploadedImage && (
          <PreviewWrapper>
            <PreviewImage
              src={
                uploadedImage.viewUrl ? uploadedImage.viewUrl : uploadedImage
              }
            />
            <PreviewName>
              {uploadedImage.originalname} <br />
              <PreviewSize>{uploadedImage.size}</PreviewSize>
            </PreviewName>
            <PreviewDelete onClick={onRemove}>Remove</PreviewDelete>
          </PreviewWrapper>
        )}
      </InputFieldWrapper>
    </>
  );
};

const UploadWrapper = styled.div`
  border: 1px dashed #d2d4dd;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
`;

const InputField = styled.input<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 12px;
  ${(props) => (props.helperText ? Colors.red : Colors.athensGrey)};
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
`;

const UploadButton = styled.label<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  width: 100px;
  height: 32px;
  background: #ff0000;
  border-radius: 8px;
  border: none;
  cursor: ${(props) => (props.disabled ? "" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.white};
  margin-top: 1rem;
  pointer-events: ${(props) => (props.disabled ? "none" : "")};
  opacity: ${(props) => (props.disabled ? "0.5" : "")};
`;

const UploadFileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UploadMessage = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 8px;
  color: ${Colors.cloudyGrey};
  margin-top: 1rem;
`;

const PreviewWrapper = styled.div`
  display: flex;
  margin-top: 0.8rem;
  position: relative;
  background: ${Colors.whiteSmoke};
`;

const PreviewImage = styled.img`
  width: 50px;
  height: 50px;
`;

const PreviewName = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: ${Colors.black};
  margin-top: 0.8rem;
  margin-left: 0.5rem;
`;

const PreviewSize = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: ${Colors.logan};
`;

const PreviewDelete = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #ea3323;
  position: absolute;
  right: 2%;
  margin-top: 1rem;
  cursor: pointer;
`;

export default UploadFile;
